module.exports = __webpack_public_path__ + "img/01.a3edf3a5.gif";